module.exports = __webpack_public_path__ + "img/cy.d069616c.svg";